import { Tooltip } from "@magnetic/tooltip";

import { Constants } from "src/utils/constants";

import { BaseColumnConfig } from "./baseColumnConfig";

export interface DetailWithtooltipColumnData {
  readonly displayData: string;
  readonly tooltipData: string;
}

/**
 * Generic column for displaying text with a tooltip on hover
 * Can be used for any column that needs to show additional details in a tooltip
 */
export class DetailWithtooltipColumn extends BaseColumnConfig<DetailWithtooltipColumnData> {
  identity(value?: DetailWithtooltipColumnData) {
    return value?.displayData.toString();
  }
  compare(a: DetailWithtooltipColumnData, b: DetailWithtooltipColumnData) {
    return a?.displayData?.localeCompare(b?.displayData);
  }

  render(data: DetailWithtooltipColumnData) {
    if (!data || !data.displayData) {
      return Constants.EMPTY_VALUE;
    }

    // Use Tooltip component to show additional details on hover
    // Using span which is inline-block to maintain proper alignment of tooltip
    // The empty title="" prevents the default browser/table tooltip from showing
    return (
      <Tooltip title={data.tooltipData}>
        <span className="mds-text-p3" title="">
          {data.displayData}
        </span>
      </Tooltip>
    );
  }
}
